import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import Navigation from '../navigation/navigation';
import { POI_ACTION_TYPES, WS_ACTION_TYPES } from '../redux-saga/actionTypes/index';
import styles from './styles';

class App extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    const { initWs } = this.props;
    initWs();
  }

  componentDidMount() {
    const {
      poiListEvent,
      poiDetailEvent,
      savePoiFromWS,
      dropRouteListEvent,
      saveSelectedPoi,
      saveRoutesList,
      markSinglePoi,
      markPoiList,
      stopInProgress,
      saveIncomingStop,
      favoriteListEvent,
      saveFavoriteList,
      saveDestinationsEvent,
      saveDestinationsList,
      recentListEvent,
      saveRecentList,
      favoriteListInprogress,
      recentListInprogress,
      quicklinksInprogress,
      routeWaypoinDetailEvent,
      saveRouteWaypoinDetails,
    } = this.props;
    poiListEvent(payload => {
      savePoiFromWS(payload);
      markPoiList(true);
    });
    if (!stopInProgress) {
      poiDetailEvent(payload => {
        saveSelectedPoi(payload);
        markSinglePoi(true);
      });
    }
    if (stopInProgress) {
      poiDetailEvent(payload => {
        saveIncomingStop(payload);
        markSinglePoi(true);
      });
    }
    favoriteListEvent(payload => {
      saveFavoriteList(payload);
      favoriteListInprogress(true);
      recentListInprogress(false);
      markPoiList(true);
    });
    recentListEvent(payload => {
      saveRecentList(payload);
      recentListInprogress(true);
      favoriteListInprogress(false);
      markPoiList(true);
    });
    saveDestinationsEvent(payload => {
      saveDestinationsList(payload);
      quicklinksInprogress(true);
    });
    dropRouteListEvent(saveRoutesList);
    routeWaypoinDetailEvent(saveRouteWaypoinDetails);
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <div className={classes.container}>
          <Navigation />
        </div>
      </React.Fragment>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
  savePoiFromWS: PropTypes.func.isRequired,
  saveSelectedPoi: PropTypes.func.isRequired,
  saveRoutesList: PropTypes.func.isRequired,
  initWs: PropTypes.func.isRequired,
  poiListEvent: PropTypes.func.isRequired,
  poiDetailEvent: PropTypes.func.isRequired,
  dropRouteListEvent: PropTypes.func.isRequired,
  markSinglePoi: PropTypes.func.isRequired,
  markPoiList: PropTypes.func.isRequired,
  stopInProgress: PropTypes.bool,
  saveIncomingStop: PropTypes.func.isRequired,
  favoriteListEvent: PropTypes.func.isRequired,
  saveFavoriteList: PropTypes.func.isRequired,
  recentListEvent: PropTypes.func.isRequired,
  saveRecentList: PropTypes.func.isRequired,
  favoriteListInprogress: PropTypes.func.isRequired,
  recentListInprogress: PropTypes.func.isRequired,
  saveDestinationsEvent: PropTypes.func.isRequired,
  saveDestinationsList: PropTypes.func.isRequired,
  quicklinksInprogress: PropTypes.func.isRequired,
  routeWaypoinDetailEvent: PropTypes.func.isRequired,
  saveRouteWaypoinDetails: PropTypes.func.isRequired,
};

App.defaultProps = {
  stopInProgress: false,
};

const mapStateToProps = ({ poi }) => ({
  stopInProgress: poi.stops_inprogress,
});

const mapDispatchToProps = dispatch => ({
  saveSelectedPoi: payload => dispatch({ type: POI_ACTION_TYPES.POI_SELECTED.LOADING, payload }),
  savePoiFromWS: payload => dispatch({ type: POI_ACTION_TYPES.POI_LIST, payload }),
  saveRoutesList: payload =>
    dispatch({ type: POI_ACTION_TYPES.ROUTES_LIST_FROM_WS.SUCCESS, payload }),
  initWs: () => dispatch({ type: WS_ACTION_TYPES.WS.INIT }),
  poiListEvent: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_LIST, payload }),
  poiDetailEvent: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_DETAIL, payload }),
  markSinglePoi: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.SINGLE_POI, payload }),
  markPoiList: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.POI_LIST_INPROGRESS, payload }),
  dropRouteListEvent: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_DROP_ROUTE_LIST, payload }),
  saveIncomingStop: payload => dispatch({ type: POI_ACTION_TYPES.INCOMING_STOP, payload }),
  favoriteListEvent: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_FAVORITE_LIST, payload }),
  recentListEvent: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_RECENT_LIST, payload }),
  saveFavoriteList: payload =>
    dispatch({ type: POI_ACTION_TYPES.FAVORITE_LIST_FROM_WS.SUCCESS, payload }),
  saveRecentList: payload =>
    dispatch({ type: POI_ACTION_TYPES.RECENT_LIST_FROM_WS.SUCCESS, payload }),
  favoriteListInprogress: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.FAVORITE_LIST_INPROGRESS, payload }),
  recentListInprogress: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.RECENT_LIST_INPROGRESS, payload }),
  saveDestinationsEvent: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_QUICKLINKS, payload }),
  saveDestinationsList: payload =>
    dispatch({ type: POI_ACTION_TYPES.QUICKLINKS_FROM_WS.SUCCESS, payload }),
  quicklinksInprogress: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.QUICKLINKS_INPROGRESS, payload }),
  routeWaypoinDetailEvent: payload =>
    dispatch({ type: WS_ACTION_TYPES.WS.ON_MESSAGES_ROUTE_WAYPOINT_DETAILS, payload }),
  saveRouteWaypoinDetails: payload =>
    dispatch({ type: POI_ACTION_TYPES.ROUTE_WAYPOINT_DETAILS.SUCCESS, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(App),
);
